import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { STLLoader } from 'three/addons/loaders/STLLoader.js';

export default defineNuxtPlugin(() => {
  // console.log(THREE);

  return {
    provide: { THREE, OrbitControls, STLLoader },
  };
});
